module.exports = __webpack_public_path__ + "assets/img/icon1.578fb509.svg";